import React from 'react'
import PropTypes from 'prop-types'
import AffinityIcon from 'components/AffinityIcon'
import { SELF_REFERENCE, CARRY_TO } from 'utils/constants'
import { classNames } from 'utils/utils'

const imgClasses = {
  [SELF_REFERENCE]: 'self-reference',
  [CARRY_TO]: 'carry-to',
}

const CarryTo = ({
  carryToType,
  onClick,
  highlightAffinity,
  affinityGroupNumber,
  className,
  'data-testid': dataTestId,
}) => {
  const imgClass = imgClasses[carryToType]
  if (!imgClass) {
    return null
  }
  return (
    <span
      className={classNames(className, 'multiple-query-carry')}
      onClick={onClick}
    >
      {highlightAffinity ? (
        <AffinityIcon groupNumber={affinityGroupNumber} />
      ) : (
        <span
          className={classNames('relation-symbol', imgClass)}
          data-testid={dataTestId}
        />
      )}
    </span>
  )
}

CarryTo.propTypes = {
  className: PropTypes.node,
  carryToType: PropTypes.string,
  onClick: PropTypes.func,
  highlightAffinity: PropTypes.bool,
  affinityGroupNumber: PropTypes.number,
  'data-testid': PropTypes.string,
}

export default CarryTo
